import { searchBox as searchBoxWidget } from 'instantsearch.js/es/widgets';

const searchBox = searchBoxWidget({
    container: '#search-input',
    placeholder: searchInputPlaceholder,
    autofocus: true,
    showReset: false,
    showLoadingIndicator: false,
    cssClasses: {
        root: 'MyCustomSearchBox',
        form: [
            'MyCustomSearchBoxForm',
            'MyCustomSearchBoxForm--subclass',
        ],
        input: 'form-control'
    },
});

export default searchBox;